import CryptoJS from 'crypto-js'
// import session from './session'
import session from './session'
import { validator } from './validate'
// import router from '@core/router'
import api from '@core/api'
import store from '@core/store/'
// const config = require('../../../config')

function isDevelop () {
  return process.env.NODE_ENV === 'development'
}
/**
 *
 * @param data 配合安全审查加密
 */
function aesDecrypt (data) {
  const key = CryptoJS.enc.Utf8.parse('abcdefgabcdefg12')
  const decrypt = CryptoJS.AES.decrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  const result = JSON.parse(CryptoJS.enc.Utf8.stringify(decrypt).toString())
  return result
}
/**
     * 树形数据转换
     * @param {*} data
     * @param {*} id
     * @param {*} pid
     */
function treeDataTranslate (data, id = 'id', pid = 'parentId') {
  var res = []
  var temp = {}
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i]
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]['children']) {
        temp[data[k][pid]]['children'] = []
      }
      if (!temp[data[k][pid]]['_level']) {
        temp[data[k][pid]]['_level'] = 1
      }
      data[k]['_level'] = temp[data[k][pid]]._level + 1
      temp[data[k][pid]]['children'].push(data[k])
    } else {
      res.push(data[k])
    }
  }
  return res
}
/**
 * 登出
 * @param {String} retPage
 * update by daffy 2018.09.21 16:16
 * 增加请求错误的处理
 */
function logout () {
  // const baseURL = config[process.env.NODE_ENV === 'production' ? 'build' : 'dev'].baseURL
  if (!this.isDevelop()) {
    if (parent) {
      parent.window.location.href = '/portal/logout'
    }
    window.location.href = '/portal/logout'
  }
  session.clear()
  // window.location.href = 'http://10.161.47.115:8001/logout'
}

/**
 * 转成树结构
 * @param {String} data 二进制数据
 * @param {String} pid 父id
 */
function convertToTreeData (data, pid) {
  const result = []
  let temp = []
  for (let i = 0; i < data.length; i++) {
    if (data[i].parentId === pid) {
      const obj = data[i]
      temp = this.convertToTreeData(data, data[i].menuId)
      if (temp.length > 0) {
        obj.children = temp
      }
      result.push(obj)
    }
  }
  return result
}

/*
 * 过滤出有权限的路由
 * @param {String} menuIdArr 权限menuId数组
 * @param {String} routerTree 路由树
 */
function validRouters (routerTree, menuIdArr) {
  const result = []
  let temp = []
  for (let i = 0; i < routerTree.length; i++) {
    // console.log(routerTree[i])
    if (routerTree[i].meta.type !== 'menu') {
      // 只过滤type!== 'menu'或 type==='menu && menuId存在menuIdArr中
      result.push(routerTree[i])
    } else if (menuIdArr.indexOf(routerTree[i].meta.menuId) >= 0) {
      // 当路由树中的id和menuIdArr中存在的话
      const obj = routerTree[i]
      if (obj.children && obj.children.length > 0) {
        temp = validRouters(obj.children, menuIdArr)
      } else {
        temp = []
      }
      if (temp.length > 0) {
        obj.children = temp
      } else {
        obj.children = []
      }
      result.push(obj)
    }
  }
  return result
}

function getFirstMenu (tree) {
  let routeName = ''
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].children && tree[i].children.length > 0) {
      routeName = getFirstMenu(tree[i].children)
      if (routeName) {
        break
      }
    } else {
      routeName = tree[i].name
      break
    }
  }
  if (routeName) {
    return routeName
  }
}
/*
 * 根据第一个参数的键值，从第二个对象中取值
 * 返回一个结果对象
 */
function extractionValue (keyTarget, valueTarget) {
  const result = {}
  Object.keys(keyTarget).forEach(key => {
    result[key] = valueTarget[key] || keyTarget[key]
  })
  return result
}

/*
 * 过滤出子菜单的第一个path
 * @param {String} routeTree 子路由树
 */
function getFirstChildPath (routeTree) {
  let result = ''
  if (routeTree) {
    if (routeTree.path) {
      result = routeTree.path
    } else {
      if (routeTree.children.length > 0) {
        result = getFirstChildPath(routeTree.children[0])
      }
    }
  }
  return result
}

/**
 * 下载文件
 * @param {String} data 二进制数据
 * @param {String} fileName 文件名
 */
function downloadFiles (data, filename) {
  // var blob = new Blob([data], {type: 'application/vnd.ms-excel'})接收的是blob，若接收的是文件流，需要转化一下
  if (typeof window.chrome !== 'undefined') {
    var link = document.createElement('a')
    link.href = window.URL.createObjectURL(data)
    link.download = filename
    link.click()
  } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE version
    var blob = new Blob([data], { type: 'application/force-download' })
    window.navigator.msSaveBlob(blob, filename)
  } else {
    // Firefox version
    var file = new File([data], filename, {
      type: 'application/force-download'
    })
    window.open(URL.createObjectURL(file))
  }
}

/**
 * 下载文件
 * @param {String} url 直接下载
 * @param {String} fileName 文件名
 */
function aDownloadFile (url, filename) {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', filename || '')
  a.setAttribute('id', 'aDownloadId')
  a.setAttribute('display', 'none')
  a.setAttribute('target', '_blank') // 打开新窗口
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 下载文件
 * @param {String} data 二进制数据
 * @param {String} fileName 文件名
 */
function downloadFile (data, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    // ie
    var blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    navigator.msSaveBlob(blob, fileName)
  } else {
    console.log('下载')
    let aLink = document.createElement('a')
    let evt = document.createEvent('MouseEvents')
    aLink.href = window.URL.createObjectURL(new Blob([data]))
    aLink.download = fileName || 'download'
    evt.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0)
    aLink.dispatchEvent(evt)
  }
}
// 自定义名称下载
function getBlob (url, cb) {
  var xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = function () {
    if (xhr.status === 200) {
      cb(xhr.response)
    }
  }
  xhr.send()
}
function saveAs (blob, filename) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, filename)
  } else {
    var link = document.createElement('a')
    var body = document.querySelector('body')
    link.href = window.URL.createObjectURL(blob)
    link.download = filename

    link.style.display = 'none'
    body.appendChild(link)
    link.click()
    body.removeChild(link)
    window.URL.revokeObjectURL(link.href)
  }
}

function downloadAndDefineName (url, filename) {
  getBlob(url, function (blob) {
    saveAs(blob, filename)
  })
}

// function debounce (vue) {
//   const on = vue.prototype.$on
//   vue.prototype.$on = function (event, callback) {
//     let timer
//     let newFunc = callback
//     if (event === 'click') {
//       newFunc = function () {
//         clearTimeout(timer)
//         timer = setTimeout(function () {
//           callback.apply(this, arguments)
//         }, 500)
//       }
//     }
//     on.call(this, event, newFunc)
//   }
// }

let timer = ''
/**
 * 延迟操作，所有的click事件都做此处理
 * @param {function} callback // 回调函数
 * @param {Date} timeout // 超时时长
 */
function delayFunc (callback, timeout = 300) {
  if (timer) {
    clearTimeout(timer)
  }
  timer = setTimeout(() => {
    callback && callback()
    timer = ''
  }, timeout)
}
/**
 *
 * @param {Function} func 传入的回调方法
 * @param {Number} wait 等待时间
 * @param {Object} options 配置
 */
const throttle = function (func, wait, options) {
  /* options的默认值
   *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
   *  options.leading = true;
   * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
   *  options.trailing = true;
   * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
   */
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function () {
    previous = options.leading === false ? 0 : new Date().now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function () {
    var now = new Date().now()
    if (!previous && options.leading === false) previous = now
    // 计算剩余时间
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    // 当到达wait指定的时间间隔，则调用func函数
    // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
    if (remaining <= 0 || remaining > wait) {
      // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      // options.trailing=true时，延时执行func函数
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

function aDownload (url) {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('download', '')
  a.setAttribute('id', 'aDownloadId')
  a.setAttribute('display', 'none')
  a.setAttribute('target', '_blank') // 打开新窗口
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

function blobDownload (url, flseName) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', url, true)
  xhr.responseType = 'blob'
  xhr.onload = () => {
    if (xhr.status === 200) {
      let a = document.createElement('a')
      a.href = window.URL.createObjectURL(xhr.response)
      a.download = flseName
      a.click()
    }
  }
  xhr.send()
}
/**
 * 将年月日转时间戳
 * @param {Number} dateStr 年月日
 */
function dateToTimestamp (dateStr) {
  if (!dateStr) {
    return ''
  }
  let date = new Date(dateStr)
  let timestamp = date.getTime()
  return timestamp
}
/**
 * 将时间戳转为完整日期字符串
 * @param {Number} time 时间戳
 */
function timeFormat (time = 0, showTime) {
  if (!time) {
    return '--'
  }
  let date = new Date(time)
  if (!date.getFullYear()) {
    return '时间格式有误'
  }
  return (
    `${date.getFullYear()}-${pad0(date.getMonth() + 1)}-${pad0(
      date.getDate()
    )}` +
    (showTime
      ? ` ${pad0(date.getHours())}:${pad0(date.getMinutes())}:${pad0(
        date.getSeconds()
      )}`
      : '')
  )
}
/**
 * 将时间戳转为完整日期字符串
 * @param {Number} time 时间戳
 */
function timeFormatMonth (time = 0) {
  let date = new Date(time)
  if (!date.getFullYear()) {
    return '时间格式有误'
  }
  return `${date.getFullYear()}-${pad0(date.getMonth() + 1)}`
}
/**
 * 将时间戳转为中文格式日期字符串
 * @param {Number} time 时间戳
 */
function timeFormatChina (time = 0) {
  let date = new Date(time)
  if (!date.getFullYear()) {
    return '时间格式有误'
  }
  return `${date.getFullYear()}年${pad0(date.getMonth() + 1)}月${pad0(
    date.getDate()
  )}日`
}
/**
 * 将时间戳转为中文格式日期字符串 间隔符合 .
 * @param {Number} time 时间戳
 */
function timeFormatNew (time = 0) {
  let date = new Date(time)
  if (!date.getFullYear()) {
    return '时间格式有误'
  }
  return `${date.getFullYear()}.${pad0(date.getMonth() + 1)}.${pad0(
    date.getDate()
  )}`
}
/**
 * 将时间戳转为完整日期字符串
 * @param {Number} time 时间戳
 * showTime 是否到秒
 */
function timeFormat2 (time = 0, showTime = false) {
  let date = new Date(+time)
  return (
    `${date.getFullYear()}-${pad0(date.getMonth() + 1)}-${pad0(
      date.getDate()
    )} ${pad0(date.getHours())}:${pad0(date.getMinutes())}` +
    (showTime ? `:${pad0(date.getSeconds())}` : '')
  )
}
function timeFormat3 (time = 0) {
  let date = new Date(+time)
  return `${date.getFullYear()}-${pad0(date.getMonth() + 1)}-${pad0(
    date.getDate()
  )}`
}
function formatPhone (phone) {
  if (!this.validate('telnumber', phone)) {
    console.error('请输入正确手机号')
    return false
  }
  return phone.replace(/(\d{3})\d*(\d{4})/, '$1****$2')
}
/*
 * 当数组字段为空时显示‘--’
 * @params [arr] arr
 * @params name 数组中某字段名
 */
function replaceSpace (arr, name) {
  return arr.filter(item => item[name]).length === 0
}
/*
 * 将时间字符串中的'/'替换成‘-’，兼容ie
 */
function replaceTime (str) {
  return str.replace(/-/g, '/')
}
/**
 * 将时间戳转为日期字符串
 * @param {Number} time 时间戳
 */
function dateFormat (time = 0, zh) {
  if (!zh) {
    if (typeof time === 'string') {
      if (time.indexOf(' ') >= 0) {
        return time.split(' ')[0]
      } else {
        return time
      }
    } else {
      let date = new Date(time)
      return `${date.getFullYear()}-${pad0(date.getMonth() + 1)}-${pad0(
        date.getDate()
      )}`
    }
  } else {
    let date = new Date(time)
    return `${date.getFullYear()}年${pad0(date.getMonth() + 1)}月${pad0(
      date.getDate()
    )}日`
  }
}

/**
 * 日期字符串 转为 时间格式
 * @param {Number} time 时间戳
 */
function stringDate (strDate) {
  var st = strDate
  var a = st.split(' ')
  var b = a[0].split('-')
  var c = a[1].split(':')
  var date = new Date(b[0], b[1] - 1, b[2], c[0], c[1], c[2])
  return date
}
/**
 * 在字符串前补零
 * @param {String} str 原字符串
 * @param {Number} count 补零个数
 */
function pad0 (str = '', count = 2) {
  let padStr = ''
  str = str + ''
  let add = count - str.length
  if (add > 0) {
    for (let i = 0; i < add; ++i) {
      padStr += '0'
    }
  }
  return padStr + str
}

/**
 * 对字符串内容进行校验
 * @param {String}} type  校验类型
 * @param {String} val 要校验的字符串
 */
function validate (type, val = '') {
  let v = validator[type]

  return v && v.test(val)
}
/*
 * 转译参数
 */
function transformationParams (data) {
  let params = ''
  for (let key in data) {
    if (data[key] === 0 || data[key]) {
      if (Object.prototype.toString.call(data[key]) === '[object Array]') {
        params = params + key + '=' + JSON.stringify(data[key]) + '&'
      } else {
        params = params + key + '=' + data[key] + '&'
      }
    }
  }
  return params
}
/*
 * 是否显示分页
 * 总数小于10条数据不显示分页
 * @param {Number} val 总条数
 */
function isOrNotPage (val = 0) {
  return val >= 10 ? 'total, prev, pager, next, sizes, jumper' : 'total'
}

let commonPageSizes = [5, 10, 20, 50]

/**
 * 值为对象的数组合并
 * @param {Array} arr1 原始数组
 * @param {Array} arr2 合并数组
 */
function concatArray (arr1, arr2, key = 'key') {
  var result = []
  arr2.map(item2 => {
    let index = arr1.findIndex(item1 => item1[key] === item2[key])
    if (index !== -1) {
      let resultIndex = result.findIndex(item => item[key] === item2[key])
      if (resultIndex === -1) {
        result.push(item2)
      }
    }
  })
  arr1.map(item1 => {
    let index = result.findIndex(item => item[key] === item1[key])
    if (index === -1) {
      result.push(item1)
    }
  })
  return result
}

/*
 * 拼接下载连接
 */
function formatDownloadUrl (url) {
  // return url + '&prev=false'
  let suffix = '&prev=false'
  if (url.indexOf('?') >= 0) {
    suffix = '&prev=false'
  } else {
    suffix = '?prev=false'
  }
  return url + suffix
}

/**
 * 对数组深层展开
 * @param {Array}} arr  目标数组
 * @param {String} childAttr 子数组属性名
 */
function spreadArr (arr, childAttr = 'children') {
  return arr.reduce((result, item) => {
    result.push(item)
    if (Array.isArray(item[childAttr])) {
      result = result.concat(spreadArr(item[childAttr], childAttr))
    }
    return result
  }, [])
}

/**
 * 检查浏览器版本
 */
function _checkVersion () {
  var _broswer = {}
  var sUserAgent = navigator.userAgent
  var isOpera = sUserAgent.indexOf('Opera') > -1
  var isChrome = sUserAgent.indexOf('Chrome') > -1
  if (isChrome) {
    _broswer.version = parseFloat(RegExp['$1'])
    _broswer.chrome = true
    _broswer.name = 'chrome'
  }
  // 排除Chrome信息，因为在Chrome的user-agent字符串中会出现Konqueror/Safari的关键字
  var isKHTML =
    (sUserAgent.indexOf('KHTML') > -1 ||
      sUserAgent.indexOf('Konqueror') > -1 ||
      sUserAgent.indexOf('AppleWebKit') > -1) &&
    !isChrome
  // !isOpera 避免是由Opera伪装成的IE
  var isIE =
    sUserAgent.indexOf('compatible') > -1 &&
    sUserAgent.indexOf('MSIE') > -1 &&
    !isOpera
  if (isIE) {
    _broswer.version = parseFloat(RegExp['$1'])
    _broswer.msie = true
    _broswer.name = 'msie'
  }
  // 排除Chrome 及 Konqueror/Safari 的伪装
  var isMoz = sUserAgent.indexOf('Gecko') > -1 && !isChrome && !isKHTML
  if (isMoz) {
    var reMoz = new RegExp('rv:(\\d+\\.\\d+(?:\\.\\d+)?)')
    reMoz.test(sUserAgent)
    _broswer.version = parseFloat(RegExp['$1'])
    _broswer.mozilla = true
    _broswer.name = 'mozilla'
  }
  return _broswer
}
/**
 * 检查是否是chrome浏览器
 */
function isChrome () {
  return _checkVersion().name === 'chrome'
}
function getFullImageUrl (tempUrl) {
  const splitIndex = tempUrl.lastIndexOf('_thumbnail')
  let url = tempUrl
  if (splitIndex !== -1) {
    url =
      tempUrl.substring(0, splitIndex) +
      tempUrl.substring(splitIndex + 10, tempUrl.length)
  }
  return url
}

/**
 * filterLabelFromArr:从数组中根据value过滤出来label
 *
 */
function filterLabelFromArr (arr, value) {
  arr = arr || []
  let result = arr.find(item => item.value === value)
  let label = ''
  if (result === undefined) {
    label = '--'
  } else {
    label = result.label
  }
  return label
}
/**
 * filterNull 判断是否为空
 * @param {*} val
 */
function filterNull (val, isNum) {
  let result = '--'
  if (!val) {
    result = isNum ? 0 : '--'
  } else {
    result = val
  }
  return result
}

/**
 * formatPhoneNo 手机号处理
 * @param {*} val
 */
function formatPhoneNo (val) {
  let result = '--'
  if (!val) {
    result = '--'
  } else {
    let reg = /^(\d{3})\d*(\d{4})$/
    result = val.replace(reg, '$1****$2')
  }
  return result
}

/**
 * 计算时间
 * @param curTime: 当前时间
 * @param n:按天往前或往后
 */
function calcTime (curTime, n) {
  console.log(curTime)
  console.log(n)
  console.log(new Date(curTime).getTime())
  return dateFormat(new Date(curTime).getTime() + n * 24 * 60 * 60 * 1000)
}
/**
 * 生产uuid
 */
function generateUUID () {
  function S4 () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (
    S4() +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    S4() +
    S4()
  )
}
/**
 * 将时间戳转为中文年月
 * @param {Number} time 时间戳
 */
function timeFormatYM (time = 0) {
  let date = new Date(time)
  if (!date.getFullYear()) {
    return '时间格式有误'
  }
  return `${date.getFullYear()}年${pad0(date.getMonth() + 1)}月`
}
/**
 * 获取当前周从周一至周日的日期
 * @param {*} strTime 当前日期
 */
function getWeek (i, date) {
  let now = new Date(date)
  let firstDay = new Date(now - (now.getDay() - 1) * 86400000)
  firstDay.setDate(firstDay.getDate() + i)
  let mon = Number(firstDay.getMonth()) + 1
  return new Date(now.getFullYear() + '-' + mon + '-' + firstDay.getDate())
}
function calcMonOrWeek (isM, strTime) {
  let now = new Date()
  strTime =
    strTime ||
    now.getFullYear() + '-' + now.getMonth() + 1 + '-' + now.getDate()
  // 将获取的字符转转换为 new date
  let date = new Date(strTime)
  if (isM) {
    let monthArr = []
    monthArr.push(date.getFullYear() + '-' + pad0(date.getMonth() + 1))
    return monthArr
  } else {
    let weekArr = []
    for (var i = 0; i < 7; i++) {
      weekArr.push(
        pad0(getWeek(i, date).getMonth() + 1) +
          '-' +
          pad0(getWeek(i, date).getDate())
      )
    }
    return weekArr
  }
}
function browserVersion () {
  const agent = navigator.userAgent.toLowerCase()
  const opera = window.opera
  let browser = {
    // 输出最终浏览器版本
    browser: 'chrome',
    // 检测当前浏览器是否为IE
    ie: /(msie\s|trident.*rv:)([\w.]+)/.test(agent),

    // 检测当前浏览器是否为Opera
    opera: !!opera && opera.version,

    // 检测当前浏览器是否是webkit内核的浏览器
    webkit: agent.indexOf(' applewebkit/') > -1,

    // 检测当前浏览器是否是运行在mac平台下
    mac: agent.indexOf('macintosh') > -1,

    // 检测当前浏览器是否处于“怪异模式”下
    quirks: document.compatMode === 'BackCompat'
  }

  // 检测当前浏览器内核是否是gecko内核
  browser.gecko =
    navigator.product === 'Gecko' &&
    !browser.webkit &&
    !browser.opera &&
    !browser.ie
  if (browser.gecko) browser.browser = 'gecko'
  let version = 0

  // Internet Explorer 6.0+
  if (browser.ie) {
    const v1 = agent.match(/(?:msie\s([\w.]+))/)
    const v2 = agent.match(/(?:trident.*rv:([\w.]+))/)
    if (v1 && v2 && v1[1] && v2[1]) {
      version = Math.max(v1[1] * 1, v2[1] * 1)
    } else if (v1 && v1[1]) {
      version = v1[1] * 1
    } else if (v2 && v2[1]) {
      version = v2[1] * 1
    } else {
      version = 0
    }
    browser.browser = 'ie'
    // 检测浏览器模式是否为 IE6 模式 或者怪异模式
    browser.ie6Compat = version < 7 || browser.quirks

    // 检测浏览器模式是否为 IE7 兼容模式
    browser.ie7Compat =
      (version === 7 && !document.documentMode) || document.documentMode === 7

    // 检测浏览器模式是否为 IE8 兼容模式
    browser.ie8Compat = document.documentMode === 8

    // 检测浏览器是否是IE8浏览器
    browser.ie8 = !!document.documentMode

    browser.ie9above = version > 8

    browser.ie9below = version < 9

    // 检测浏览器模式是否为 IE9 兼容模式
    browser.ie9Compat = document.documentMode === 9

    // 检测浏览器模式是否为 IE10 兼容模式
    browser.ie10Compat = document.documentMode === 10

    // 检测浏览器模式是否为 IE11 兼容模式
    browser.ie11Compat = document.documentMode === 11
  }
  // Gecko.
  if (browser.gecko) {
    // eslint-disable-next-line no-useless-escape
    var geckoRelease = agent.match(/rv:([\d\.]+)/)
    if (geckoRelease) {
      geckoRelease = geckoRelease[1].split('.')
      version =
        geckoRelease[0] * 10000 +
        (geckoRelease[1] || 0) * 100 +
        (geckoRelease[2] || 0) * 1
    }
  }

  // 检测当前浏览器是否为Chrome, 如果是，则返回Chrome的大版本号
  if (/chrome\/(\d+\.\d)/i.test(agent)) {
    browser.chrome = +RegExp['\x241']
    browser.browser = 'chrome'
  }

  // 检测当前浏览器是否为Safari, 如果是，则返回Safari的大版本号
  if (
    /(\d+\.\d)?(?:\.\d)?\s+safari\/?(\d+\.\d+)?/i.test(agent) &&
    !/chrome/i.test(agent)
  ) {
    browser.safari = +(RegExp['\x241'] || RegExp['\x242'])
    browser.browser = 'safari'
  }

  // Opera 9.50+
  if (browser.opera) {
    version = parseFloat(opera.version())
    browser.browser = 'opera'
  }

  // WebKit 522+ (Safari 3+)
  if (browser.webkit) {
    version = parseFloat(agent.match(/ applewebkit\/(\d+)/)[1])
  }

  // 检测当前浏览器版本号
  browser.version = version

  return browser
}
/**
 * 时间戳转化为年 月 日 时 分 秒
 * value: 传入时间戳||Date对象||字符串
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致
 */
const formatTime = (value, format = 'yyyy-MM-dd') => {
  if (!value) return '--'
  var formateArr = ['yyyy', 'MM', 'dd', 'h', 'm', 's']
  var returnArr = []
  var date
  if (Object.prototype.toString.call(value) === '[object String]') {
    let dateStr = value
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '')
      .replace(/(-)/g, '/')
    if (dateStr.indexOf('.') > 0) { dateStr = dateStr.slice(0, dateStr.indexOf('.')) }
    date = new Date(dateStr)
  } else {
    date = new Date(value)
  }
  returnArr.push(date.getFullYear())
  returnArr.push(formatNumber(date.getMonth() + 1))
  returnArr.push(formatNumber(date.getDate()))
  returnArr.push(formatNumber(date.getHours()))
  returnArr.push(formatNumber(date.getMinutes()))
  returnArr.push(formatNumber(date.getSeconds()))
  for (var i in returnArr) {
    format = format.replace(formateArr[i], returnArr[i])
  }
  return format
}
// 数据转化
function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
// 简单表单数据重置
function restForm (data) {
  let obj = data
  for (let key in data) {
    if (Object.prototype.toString.call(data[key]) === '[object Array]') {
      data[key] = []
    } else if (
      Object.prototype.toString.call(data[key]) === '[object Object]'
    ) {
      data[key] = {}
    } else {
      data[key] = ''
    }
  }
  return obj
}

/**
 * 计算合并行或列
 * @param {*} data
 */
function getColspanArr (data, compareName) {
  data = data || []
  data = data.filter(item => !!item)
  if (data && data.length > 0) {
    let pos = 0
    let colspanArr = []
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        colspanArr.push(1)
        pos = 0
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i][compareName] === data[i - 1][compareName]) {
          colspanArr[pos] += 1
          colspanArr.push(0)
        } else {
          colspanArr.push(1)
          pos = i
        }
      }
    }
    return colspanArr
  } else {
    return []
  }
}

/**
 * 计算两个日期相差多少个月多少天
 * @param {*} endDate 结束日期
 * @param {*} startDate 开始日期
 *
 */
function getDistanceDay (endTime, startTime) {
  if (startTime && endTime) {
    let startYear = new Date(startTime).getFullYear()
    let endYear = new Date(endTime).getFullYear()
    let starMonth = new Date(startTime).getMonth() + 1
    let endMonth = new Date(endTime).getMonth() + 1
    let startDays = new Date(startTime).getDate()
    let endDays = new Date(endTime).getDate()
    let year = endYear - startYear
    let month = endMonth - starMonth
    let day

    let startMonthDays = new Date(startYear, starMonth, 0).getDate()
    let endMonthDays = new Date(endYear, endMonth, 0).getDate()

    if (month < 0) {
      year--
      month = endMonth + (12 - starMonth)
    }
    console.log(endDays, '----', endMonthDays)
    if (endDays === endMonthDays) {
      if (startMonthDays - startDays === startMonthDays - 1) {
        month++
        day = 0
      } else {
        console.log('1111')
        let val = endMonth === 2 ? startMonthDays - endMonthDays : 0
        day = endDays + (startMonthDays - startDays) - endMonthDays + 1 - val
      }
    } else if (endDays + 1 + (startMonthDays - startDays) >= startMonthDays) {
      day = endDays + (startMonthDays - startDays) - startMonthDays + 1
    } else {
      month--
      day = endDays + (startMonthDays - startDays) + 1
    }

    let result = ''
    if (month <= 0 && year <= 0) {
      result = day * 1 + '天'
    } else if (day > 0) {
      result = month * 1 + year * 12 + '个月' + day * 1 + '天'
    } else {
      result = month * 1 + year * 12 + '个月'
    }
    return result
  } else {
    return ''
  }
}
//  function mianViewHeight(viewName, isShowSearch) {
//   // 传入页面名称或对应组件的名称
//   // console.log(viewName)
//   const mianHeight = store.getters.mianViewHeight
//   var rest = 0 // 页面剩余需要减去的高度
//   switch (viewName) {
//     case 'dashboard':
//       rest = 4
//       break
//     case 'modules-form': // 流程模型管理-表格
//     case 'deployment': // 流程定义管理
//       rest = 215
//       break
//     case 'modules-chart': // 流程模型管理-图示
//       rest = 6
//       break
//     case 'startflow': // 流程发起日志
//       rest = 165
//       break
//     case 'formulaManage-form': // 公式管理-表格
//       rest = 164
//       break
//     case 'monthReportTask': // 月报任务
//     case 'summaryOfAssetsMonthlyReport-form': // 2019资产月报汇总-表格
//       rest = 100
//       break
//     case 'administrativeMonthlyReport-form': // 行政事业单位资产月报-表格
//       rest = 675
//       break
//     case 'monthly': // 单位月结查询
//       rest = 276
//       break
//     case 'warehouse': // 物品登记
//     case 'supplier': // 物品登记
//     case 'goodsRegister': // 物品登记
//     case 'keyUsageAssets': // 重点资产表
//     case 'assetClassification-form': // 资产分类维护-表格
//       rest = 320
//       break
//     case 'ThePersonnel-form': // 人员维护-表格
//     case 'place-form': // 存放地点维护-表格
//     case 'jobTitle-form': // 职称维护-表格
//     case 'TheDepartment-form': // 部门-表格
//       rest = 296
//       break
//     case 'assetQuery': // 资产查询
//     case 'historyAssetQuery': // 资产历史情况表
//       rest = 276
//       break
//     case 'integratedManagement-form': // 快速管理-表格
//       rest = 251
//       break
//     case 'myAssets': // 我的资产
//       rest = 252
//       break
//     case 'internalTransfer': // 内部调拨查询
//     case 'personaInventory': // 个人版盘点
//       rest = 272 - 12
//       break
//     // case 'labelPrint': // 标签打印
//     //   rest = 240
//     //   break
//     case 'luohuProperty': // 罗湖区物业
//     case 'labelPrint-form': // 标签打印-表格
//     case 'bulkImport': // 批量导入
//     case 'registerAsset': // 资产登记
//       rest = 253
//       break
//     case 'cardExamination': // 卡片体检
//       rest = 282
//       break
//     case 'professionalTitleIndex': // 职称指标
//     case 'memberIndex': // 成员指标
//       rest = 336
//       break
//     case 'labelPrint-label': // 标签打印-标签
//       rest = 328
//       break
//     case 'integratedManagement-menu': // 快速管理-菜单
//       rest = 62
//       break
//     case 'administrativeMonthlyReport-menu': // 行政事业单位资产月报-菜单
//       rest = 70
//       break
//     case 'summaryOfAssetsMonthlyReport-menu': // 2019资产月报汇总-菜单
//       rest = 500
//       break
//     case 'ThePersonnel-menu': // 人员维护-菜单
//     case 'place-menu': // 存放地点维护-菜单
//     case 'jobTitle-menu': // 职称维护-菜单
//     case 'TheDepartment-menu': // 部门-菜单
//       rest = 111
//       break
//     case 'formulaManage-menu': // 公式管理-菜单
//     case 'unitProcessConfig-form': // 单位流程配置-表格
//     case 'unitParam-menu': // 单位参数配置-菜单
//     case 'assetClassification-menu': // 资产分类维护-菜单
//       rest = 104
//       break
//     case 'unitProcessConfig-tips': // 单位流程配置-提示
//       rest = 115
//       break
//     case 'policies-table': // 政策法规
//     case 'unitProcessConfig-menu': // 单位流程配置-菜单
//       rest = 106
//       break
//     case 'unitParam-form': // 单位参数配置-表格
//       rest = 261
//       break
//     case 'TheOrganize': // 单位基本信息
//       rest = 260
//       break
//     case 'coderule': // 编码规则
//       rest = 451
//       break
//     case 'enclosure-picture': // 附件-图片
//       rest = 186
//       break
//     case 'enclosure-form': // 附件-表格
//       rest = 489
//       break
//     case 'flowChart': // 流程图
//       rest = 426 + 19
//       break
//     case 'initIndexAllocation': // 资产指标配置
//       rest = 92
//       break
//     case 'addClassNames': // 新增易耗品登记
//       rest = 12
//       break
//     case 'indicatorUsage': // 指标使用状况
//       rest = 92
//       break
//     case 'disposalApplicationForm': // 处置申请单
//       rest = 468
//       break
//     case 'adjustment_application_form': // 调剂申请单
//     case 'adjustment_application_form_edit': // 调剂申请单（修改）
//     case 'transfer_application_form': // 移交申请单
//     case 'transfer_application_form_add': // 移交申请单新增
//     case 'transfer_application_form_edit': // 移交申请单修改
//     case 'adjustment_application_form_add': // 调剂申请单新增
//     case 'adjustment_application_form_edit': // 调剂申请单修改
//       rest = 476
//       break
//     case 'formula_form_tabs': // 公式管理表单标签页
//       rest = 600
//       break
//     case 'application_form_acquisition': // 领用申请单
//     case 'return_application_form': // 退库申请单
//     case 'release_application_form': // 放行申请单
//     case 'allocation_application_form': // 调拨申请单
//       rest = 476 + 17
//       break
//     case 'asset_application_form': // 资产申请单
//       rest = 458 + 7
//       break
//     case 'lease_application_form': // 出租申请单
//       rest = 540 + 17
//       break
//     case 'loan_application_form': // 出借申请单
//       rest = 540 + 18
//       break
//     case 'TheCapitalProjects': // 资金项目
//       rest = 515
//       break
//     case 'qsset_registration_add-menu': // 资产登记新增-菜单
//       rest = 86
//       break
//     case 'qsset_registration_add-form': // 资产登记新增-表格
//       rest = 86
//       break
//     case 'qsset_registration_modify': // 资产登记修改
//     case 'qsset_registration_modify_new': // 资产登记修改
//       rest = 66
//       break
//     case 'certificateManage': // 凭证管理
//       rest = 436
//       break
//     case 'summaryAssets': // 资产汇总表
//       rest = 243
//       break
//     case 'increaseOrDecrease': // 资产增减变化表
//       rest = 300
//       break
//     case 'assets_warehousing_form': // 资产入库申请单
//       rest = 327 + 25 + 105
//       break
//     case 'assets_warehousing_form-process': // 资产入库申请单(流程)
//       rest = 438 + 19
//       break
//     case 'assets_earning_form-process': // 收益登记
//       rest = 490 + 19
//       break
//     case 'assetsStoreQuery': // 公物仓查询
//     case 'disposalAssetQuery': // 处置资产查询
//       rest = 256
//       break
//     case 'general': // 一般属性修改
//       rest = 330
//       break
//     case 'equity_investment-form': // 股权投资项目-表格
//       rest = 84
//       break
//     case 'equity_investment-menu': // 股权投资项目-菜单
//       rest = 86 + 37
//       break
//     case 'engineering_allocation': // 工程调拨申请单
//       rest = 86 + 37 + 366
//       break
//     case 'warningInformation': // 预警信息
//       rest = 9 + 15
//       break
//     case 'inspectionTaskList': // 巡检变更列表
//       rest = 72
//       break
//     case 'asset_inventory_task_sheet': // 资产盘点任务单
//     case 'asset_inventory_task_sheet_add': // 资产盘点任务单新增
//     case 'asset_inventory_task_sheet_edit': // 资产盘点任务单修改
//       rest = 372 + 85
//       break
//     case 'asset_maintenance': // 资产维修单
//     case 'asset_maintenance_add': // 资产维修单新增
//     case 'asset_maintenance_edit': // 资产维修单修改
//       rest = 437 + 72
//       break
//     case 'assetDisposal': // 资产处置情况表
//     case 'assetsGet': // 资产取得情况表
//     case 'assetsUse': // 资产使用情况表
//       rest = 278
//       break
//     case 'view_card': // 查看卡片
//       rest = 66
//       break
//     case 'construction_in_progress_modify': // 在建工程项目修改
//     case 'construction_in_progress_add': // 在建工程项目新增
//       rest = 66
//       break
//     case 'policies-menu': // 政策法规
//       rest = 69
//       break
//     case 'lawsRegulations-table': // 政策法规
//     case 'lawsRegulations-menu': // 政策法规
//       rest = 138
//       break
//     case 'assetEntry': // 资产入账
//       rest = 10
//       break
//     case 'depreciation': // 折旧
//       rest = 30
//       break
//     case 'depreciations': // 月度折旧
//       rest = 243
//       break
//     case 'depreciationes': // 月度折旧
//       rest = 230
//       break
//     case 'accountCheck': // 对账
//       rest = 30
//       break
//     case 'repottingTasks': // 上报任务
//       rest = 270
//       break
//     case 'certificate-menu':
//       rest = 30
//       break
//     default:
//       break
//   }
//   if (!isShowSearch && isShowSearch !== undefined) {
//     return mianHeight - rest + 105
//   }
//   return mianHeight - rest
// }
/**
 * 埋点数据加密，commonKey 写死
 * md5Encrypted  md5加密方法
 */
function md5Encrypted (timestamps) {
  let commonKey = '3Pi4Os1parkKA1ND5LLsORnoarGLzgcc'
  let str = `${timestamps}${commonKey}`
  let result = CryptoJS.MD5(str).toString()
  return result
}
function S4 () {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
}
function getCommonId () {
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}
/**
 * 通用埋点方法
 * @param type       必填。事件类型, 点击事件 2000
 *                      新增事件: 10000
 *                      删除事件: 20000
 *                      修改事件: 30000
 *                      查询事件: 40000
 *                      执行事件: 50000
 * @param name       必填。事件名称，由产品经理理定义
 * @param params     非必填。自定义参数，填了需包含 mobile/action_type/action_key
 *                      mobile:         操作人联系方式(不需要手动传，接口处统一获取)
 *                      action_type:    行为名称
 *                      action_key:     埋点内容
 *                      action_value:   埋点参数说明，可为空(String，多个则用中划线隔开，例：青羊-张三-企业A；青羊-张三-[门禁1/门禁2/门禁3])
 * @param timestamps 非必填。事件的时间戳列列表(Array)，多个事件可能具体内容⼀一样，仅仅是时间戳不不⼀一样
 */
function commonEventTrack ({type, name, params, timestamps}) {
  let curTimestamp = new Date().getTime()
  let commonId = `${curTimestamp}-` + getCommonId()
  const tmp = {
    // 如果 platform 是 web/miniapp，固定使用md5加密，因为后台对这两种类型采取的是 md5加密，其他类型采取 3des加密
    result: md5Encrypted(curTimestamp),
    random_time: curTimestamp,
    device_id: commonId, // web无法获取ip，自行生成唯一的uuid
    platform: 'web',
    events: [
      {
        event_id: commonId,
        type: type,
        name: name,
        user_id: store.getters.userInfo.id,
        user_nick: store.getters.userInfo.realName || store.getters.userInfo.nickName,
        park_id: store.getters.userInfo.parkId, // 园区id
        company_id: store.getters.userInfo.companyId,
        params: params,
        timestamps: timestamps || [curTimestamp] // 不传则默认当前时间戳
      }
    ]
  }
  if (tmp.events[0].params) {
    tmp.events[0].params.mobile = store.getters.userInfo.phone // 带上当前操作人手机号
    tmp.events[0].params = JSON.stringify(tmp.events[0].params) // 后台接收 string 类型
  } else {
    tmp.events[0].params = ''
  }
  api.commonService.eventtrackCommit(tmp).then(data => {})
}

let deboundceTimer = null
// 防抖动函数
function debounce (fn, delay = 300) {
  // 维护一个 timer
  clearTimeout(deboundceTimer)
  deboundceTimer = setTimeout(function () {
    fn()
  }, delay)
}
/**
 * 给图片加水印
 * @param {*} url 图片地址
 * @param {*} text 水印内容
 *
 */
function addWaterMark (url, text, imgName) {
  text = text || '仅作为通明湖公寓入住使用'
  console.log(url)
  var canvas1 = document.createElement('canvas')
  canvas1.setAttribute('id', 'canvas')

  var canvas2 = document.createElement('canvas')
  canvas2.setAttribute('id', 'waterCanvas')

  // var pre = 'https://yizhuang-stg.yun.city.pingan.com:30001'
  // var pre = (window.location.hostname === 'localhost') ? 'https://yizhuang-stg.yun.city.pingan.com:30001/' : (window.location.protocol + '//' + window.location.host + '/')
  var img = new Image()
  img.src = url

  var ctx = canvas1.getContext('2d')
  var waterCtx = canvas2.getContext('2d')

  // 水印canvas的样式
  waterCtx.font = '30px Aril bold'
  waterCtx.fillStyle = 'rgba(0,0,0,.3)'
  waterCtx.rotate(-25 * Math.PI / 180)
  waterCtx.textAlign = 'center'
  waterCtx.textBaseline = 'midddle'
  if (waterCtx.measureText(text).width > 180) {
    var size = 180 / text.length
    waterCtx.font = '800 ' + size + 'px ' + ' Microsoft JhengHei'
  }
  waterCtx.fillText(text, 60, 100)
  let lastIndex = url.lastIndexOf('.')
  let imgSuffix = lastIndex > 0 ? (url.slice(lastIndex + 1) || 'jpeg') : 'jpeg'
  imgSuffix = imgSuffix.toLowerCase(imgSuffix)
  // imgSuffix = imgSuffix === 'jpg' ? 'jpeg' : imgSuffix
  console.log('图片后缀：', imgSuffix)
  // 图片加载完后，去执行其他操作
  img.onload = function () {
    ctx.drawImage(img, canvas1.width - img.width, canvas1.height - img.height)
    ctx.drawImage(canvas2, canvas1.width - canvas2.width, canvas1.height - canvas2.height)
    var imgOut = canvas1.toDataURL('image/' + imgSuffix)
    console.log('图片：', imgOut)
    downloadAddWatermarkFile(imgOut, imgName)
    return imgOut
  }
}

function base64ToBlob (code) { // base64转blob
  let parts = code.split(';base64,')
  let contentType = parts[0].split(':')[1]
  let raw = window.atob(parts[1])
  let rawLength = raw.length

  let uInt8Array = new Uint8Array(rawLength)

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i)
  }
  return new Blob([uInt8Array], {type: contentType})
}

function downloadAddWatermarkFile (content, fileName) {
  let aLink = document.createElement('a')
  let blob = base64ToBlob(content) // new Blob([content]);

  let evt = document.createEvent('HTMLEvents')
  evt.initEvent('click', true, true)// initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
  aLink.download = fileName
  aLink.href = URL.createObjectURL(blob)

  aLink.click()
}

// 检查是否加入公司
function validateRegisted (rule, value, callback) {
  if (!value) {
    callback()
    return false
  }
  const params = { phone: value }
  api.commonService.findUserIsExit(params).then(res => {
    if (!res.errorMessage) {
      if (!res.body || this.isEdit) {
        callback()
      } else {
        if (this.companyId ? this.companyId !== res.body.companyId : res.body.companyId) {
          callback(new Error('该用户已加入其它公司'))
        } else {
          callback()
        }
      }
    }
  })
}

function getCookie (e) {
  for (var t = e + '=', n = document.cookie.split(';'), a = 0; a < n.length; a++) {
    var o = n[a].trim()
    if (o.indexOf(t) === 0) { return o.substring(t.length, o.length) }
  }
  return ''
}

function validRoutersJOSN (menuTree, permissionList, callback) {
  // 1. 查找符合条件的菜单项
  const validMenuItem = menuTree.find(item => {
    const isMenuType = item.meta && item.meta.type === 'menu'
    const hasPermission = permissionList.some(permission => permission.code === item.meta.menuId)
    return isMenuType && hasPermission
  })

  // 2. 如果找到的菜单项有子菜单，则递归查找子菜单
  if (validMenuItem.children.length > 0) {
    validRoutersJOSN(validMenuItem.children, permissionList, callback)
  } else {
    // 3. 调用回调函数，传入找到的菜单项或 null
    callback(validMenuItem || null)
  }
}

function validRoutersJOSN2 (t, n, a) {
  // 第一步：在数组 t 中查找满足条件的路由对象
  var o = t.find(function (e) {
    // 检查当前路由对象的 meta.type 是否为 "menu"
    if (e.meta.type === 'menu') {
      // 检查 n 数组中是否存在 code 等于当前路由对象 meta.menuId 的元素
      return n.some(function (t) {
        return t.code === e.meta.menuId
      })
    }
  })

  // 第二步：根据查找结果进行处理
  if (o && o.children && o.children.length > 0) {
    // 如果找到了满足条件的路由对象 o，并且 o 有子路由（children 数组不为空）
    // 则递归调用函数 e，继续在子路由数组中查找
    validRoutersJOSN2(o.children, n, a)
  } else {
    // 如果没有找到满足条件的路由对象，或者找到的路由对象没有子路由
    // 则将找到的结果（o 或 null）传递给回调函数 a
    a(o || null)
  }
}

const utils = {
  validRoutersJOSN2,
  validRoutersJOSN,
  getCookie,
  commonEventTrack,
  pad0,
  treeDataTranslate,
  aesDecrypt,
  validate,
  downloadFile,
  downloadFiles,
  convertToTreeData,
  validRouters,
  getFirstMenu,
  getFirstChildPath,
  timeFormat,
  timeFormat2,
  timeFormatMonth,
  timeFormatChina,
  formatPhone,
  replaceSpace,
  replaceTime,
  dateFormat,
  isOrNotPage,
  logout,
  formatDownloadUrl,
  aDownload,
  blobDownload,
  downloadAndDefineName,
  transformationParams,
  spreadArr,
  timeFormatNew,
  extractionValue,
  dateToTimestamp,
  delayFunc,
  isChrome,
  throttle,
  concatArray,
  getFullImageUrl,
  // debounce,
  filterLabelFromArr,
  filterNull,
  formatPhoneNo,
  calcTime,
  calcMonOrWeek,
  commonPageSizes,
  isDevelop,
  browserVersion,
  formatTime,
  restForm,
  aDownloadFile,
  generateUUID,
  timeFormat3,
  getColspanArr,
  getDistanceDay,
  timeFormatYM,
  stringDate,
  debounce,
  addWaterMark,
  base64ToBlob,
  downloadAddWatermarkFile,
  validateRegisted
}

// for (let key in session) {
//   utils[key + 'Session'] = session[key]
// }

export default utils



// WEBPACK FOOTER //
// ./src/area-base/utils/index.js